module.exports = __webpack_public_path__ + "static/stacey-1456db9c0f3b343c68a396785b5453b7.png";